import React, { Component } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { AxiosInstance } from 'axios'
import { withTranslation, WithTranslation } from 'react-i18next'
import { getmeta, Meta } from '../common'
import { Breadcrumb, Container, Grid, Icon, Input, Loader, List, ListContent, ListHeader, ListIcon, ListItem, Message, Modal, Segment, Dimmer } from 'semantic-ui-react'
import "./Files.css"

interface FileSelectState {
    loading: boolean,
    errorMsg: string,
    listing: any[],
    currentType: string|null,
    currentIsFile: boolean,
    currentIsUnknown: boolean,
    outFileName: string
}

interface FileSelectProps extends WithTranslation, RouteComponentProps {
    meta: Meta,
    http: AxiosInstance,
    rootType: string,
    initialType?: string,
    initialIsFile?: boolean,
    output?: boolean,
    rename?: string,
    setSelected: (type) => void
}

class FileSelect extends Component<FileSelectProps, FileSelectState> {

    state = {
        loading: false,
        errorMsg: '',
        listing: [],
        currentType: null as string|null,
        currentIsFile: false,
        currentIsUnknown: true,
        outFileName: ''
    }

    getListing() {
        const { t, meta } = this.props
        const { currentType } = this.state
        const curType = currentType===null ? '' : (currentType.endsWith(':') ? currentType : currentType+':')
        const path = curType.replace(/^:/,'_/').replaceAll(':', '/')
        this.setState({loading: true})
        const url = 'files/'+path
        this.props.http.get(url)
            .then(response => {
                const data = response.data.data
                if (Array.isArray(data)) {
                    const listing = this.filterFirstLevel(this.addMeta(currentType, data))
                    this.setState({listing: listing, errorMsg: '', loading: false})
                } else {
                    this.setState({listing: [], errorMsg: '', loading: false, currentIsFile: true})
                }
            }).catch(err => {
                if (err.response) {
                    this.setState({errorMsg: err.response.data.message||err.response.data, loading: false, listing: []})
                } else {
                    console.log(err)
                    this.setState({errorMsg: t('Unknown error'), loading: false, listing: []})
                }
            })
    }

    addMeta(type: string|null, data: any[]) {
        const { meta } = this.props
        let list = data.map(i => ({label: i.name, ...i, type: type!==null ? type+':'+i.name : '', meta: getmeta(meta, 'user_files', type!==null ? type+':'+i.name : '', 'resources')}))
        // sort directories/folders/types first, then by name
        return list.sort((a,b) => (a.dir && !b.dir) ? -1 : ((!a.dir && b.dir) ? 1 : (
                    (a.name < b.name) ? -1 : ((a.name > b.name) ? 1 : 0))
                ))
    }

    filterFirstLevel(list) {
        const { meta, t } = this.props
        if (this.state.currentType!==null) return list
        else {
            let global = list.find(x => x.name==='_global')
            let users = list.find(x => x.name===meta.user['id'])
            let ret: any[] = []
            if (global) {
                global.label = t('Global')
                global.name = '_/'
                ret.push(global)
            }
            if (users) {
                users.label = t('Private')
                ret.push(users)
            }
            return ret
        }
    }

    testFile() {
        const { t, meta } = this.props
        const { currentType } = this.state
        const path = currentType ? currentType.replace(/^:/,'_/').replaceAll(':', '/') : ''
        if (!path)
            this.setState({currentIsFile: false, currentIsUnknown: false})
        this.setState({loading: true})
        const url = 'files/'+path+'?testfile=1'
        this.props.http.get(url)
            .then(response => {
                const isFile = response.data.data
                this.setState({errorMsg: '', loading: false, currentIsFile: isFile, currentIsUnknown: false})
            }).catch(err => {
                if (err.response) {
                    this.setState({errorMsg: err.response.data.message||err.response.data, loading: false})
                } else {
                    console.log(err)
                    this.setState({errorMsg: t('Unknown error'), loading: false})
                }
            })
    }

    componentDidMount(): void {
        if (this.props.initialType) {
            const initialState = { currentType: this.props.initialType }
            if (typeof this.props.initialIsFile !== 'undefined') {
                initialState['currentIsFile'] = this.props.initialIsFile
                initialState['currentIsUnknown'] = false
            }
            if (this.props.rename) {
                initialState['outFileName'] = this.props.rename
            }
            this.setState(initialState)
        } else
            this.setState({currentType: this.props.rootType, currentIsFile: false})
    }

    componentDidUpdate(prevProps: Readonly<FileSelectProps>, prevState: Readonly<FileSelectState>, snapshot?: any): void {
        if (this.state.loading) return
        if (this.state.currentIsUnknown && !this.state.errorMsg) {
            this.testFile()
            return
        }
        if (this.state.currentType !== prevState.currentType || this.state.currentIsUnknown !== prevState.currentIsUnknown) {
            if (this.state.currentType===null || (!this.state.currentIsFile && !this.state.outFileName)) {
                this.props.setSelected('')
            } else {
                const curType = this.state.outFileName ? this.state.currentType+':'+this.state.outFileName : this.state.currentType
                this.props.setSelected(curType)
            }
            if (!this.state.currentIsFile)
                this.getListing()
        }
    }

    setNewOutFileName(name: string) {
        const newname = name.replaceAll(/[\s:]/g, '')
        if (newname && this.state.currentType!==null) {
            const newtype = this.state.currentType + ':' + newname.replaceAll('/',':')
            this.props.setSelected(newtype)
            this.setState({outFileName: newname, currentIsFile: true})
        } else {
            this.props.setSelected('')
            this.setState({outFileName: '', currentIsFile: false})
        }
    }

    render() {
        const { t, history, meta, rootType, output, rename} = this.props
        const { loading, listing, currentType, currentIsFile, outFileName } = this.state
        const myMeta = getmeta(meta, 'user_files', currentType|| '', 'resources')


        const parts = currentType!==null ? currentType.split(':') : null
        const pathSections = parts ? parts.reduce((acc, cur, i) => {
            let label = cur
            if (i===0) {
                if (label==='') label = t('Global')
                else if (label===meta.user['id']) label = t('Private')
            }
            const curtype = [...acc.map(x => x.key), cur].join(':')
            const link = i!==parts.length-1 && curtype.length >= rootType.length
            const active = !link
            let sec = {
                key: cur,
                content: label,
                link: link,
                active: active,
                onClick: link ? () => this.setState({currentType: curtype, currentIsFile: false}) : undefined
            }
            acc.push(sec)
            return acc
            }, [] as any[])
            : []
        if ((output || rename) && (!currentIsFile || outFileName)) {
            pathSections.push({
                key: '__newfile',
                content: (
                    <Input value={outFileName} onChange={(e, {value})=>this.setNewOutFileName(value)} className="breadcrumb-big"
                        placeholder={t('new file name')}/>
                )
            })
        }
        const sections = [{
            key: '',
            content: <Icon name="home"/>,
            onClick: !rootType ? () => this.setState({currentType: null, currentIsFile: false}) : undefined
        }].concat(pathSections)

        function fileSizeIEC(size) {
            var i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024))
            return +((size / Math.pow(1024, i)).toFixed(2)) * 1 + ' ' + ['B', 'kiB', 'MiB', 'GiB', 'TiB'][i]
        }

        return(
            <>
            <>{this.state.errorMsg ?
              (
                <Container>
                    <Message error icon='exclamation triangle' header={t('Error')} content={this.state.errorMsg}/>
                </Container>
              )
              : null }
            </>
            <Grid className="compact">
                <Grid.Row>
                    <Grid.Column width={16}>
                        <Breadcrumb sections={sections} size='big'/>
                    </Grid.Column>
                </Grid.Row>
                { !currentIsFile || rename ?
                <Grid.Row>
                    <Grid.Column width={16}>
                    <Segment className="files">
                        { loading? 
                        <Dimmer active inverted><Loader inverted/></Dimmer> 
                        :
                        <List>
                        {listing.map((i: any) => (
                            <ListItem disabled={!i.meta._can_read} 
                                title={t('size: {{size}}, last change: {{mtime}}, created: {{ctime}}',
                                    {
                                        size: fileSizeIEC(i.size), 
                                        ctime: i.ctime ? new Date(i.ctime.replace(' ','T')).toLocaleString() : '-',
                                        mtime: i.mtime ? new Date(i.mtime.replace(' ','T')).toLocaleString() : '-'
                                    })}>
                                <ListIcon name={i.meta._can_read ? (i.dir ? 'folder' : 'file') : 'lock'}/>
                                <ListContent>
                                    <ListHeader>
                                        { !rename || i.dir ?
                                        <div className="label" onClick={() => this.setState({currentType: i.type, currentIsFile: !i.dir})}>
                                            {i.label}
                                        </div>
                                        :
                                        <div className="inactive">
                                            {i.label}
                                        </div>
                                        }
                                    </ListHeader>
                                </ListContent>
                            </ListItem>
                        ))}
                        </List>
                        }
                    </Segment>
                    </Grid.Column>
                </Grid.Row>
                : null }
            </Grid>
            </>
        )
    }
}

export default withTranslation()(FileSelect)